/* =========================================================
   Voluema — Before/After slider (Vanilla JS, no dependencies)
   Works with pointer, touch and keyboard. Re-inits in the
   Shopify theme editor via shopify:section:load.
   ========================================================= */
(function () {
  'use strict';

  function initSlider(frame) {
    if (frame.__baInit) return;
    frame.__baInit = true;

    var range = frame.querySelector('.ba-range');
    var dragging = false;

    function clamp(n) { return Math.max(0, Math.min(100, n)); }

    function setPos(pct) {
      pct = clamp(pct);
      frame.style.setProperty('--pos', pct + '%');
      if (range && parseFloat(range.value) !== pct) range.value = pct;
    }

    function pctFromClientX(clientX) {
      var rect = frame.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function onDown(e) {
      dragging = true;
      frame.classList.add('is-dragging');
      if (frame.setPointerCapture && e.pointerId != null) {
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      }
      setPos(pctFromClientX(e.clientX));
    }
    function onMove(e) {
      if (!dragging) return;
      setPos(pctFromClientX(e.clientX));
    }
    function onUp() {
      dragging = false;
      frame.classList.remove('is-dragging');
    }

    // Pointer events cover mouse + touch + pen
    frame.addEventListener('pointerdown', onDown);
    frame.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);

    // Fallback for very old browsers without Pointer Events
    if (!('PointerEvent' in window)) {
      frame.addEventListener('mousedown', function (e) { onDown(e); });
      window.addEventListener('mousemove', function (e) { if (dragging) setPos(pctFromClientX(e.clientX)); });
      window.addEventListener('mouseup', onUp);
      frame.addEventListener('touchstart', function (e) { dragging = true; setPos(pctFromClientX(e.touches[0].clientX)); }, { passive: true });
      frame.addEventListener('touchmove', function (e) { if (dragging) setPos(pctFromClientX(e.touches[0].clientX)); }, { passive: true });
      window.addEventListener('touchend', onUp);
    }

    // Keyboard via the range input
    if (range) {
      range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
    }

    // A gentle "peek" animation the first time it scrolls into view
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var seq = [50, 68, 34, 50], i = 0;
          var t = setInterval(function () {
            setPos(seq[i]); i++;
            if (i >= seq.length) clearInterval(t);
          }, 380);
        });
      }, { threshold: 0.55 });
      io.observe(frame);
    }

    setPos(range ? parseFloat(range.value) : 50);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ba]').forEach(initSlider);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.Voluema = window.Voluema || {};
  window.Voluema.initBeforeAfter = initAll;
})();
